module.exports = __webpack_public_path__ + "img/schadensmeldungLogoDark.83668e40.svg";